import { IProductDetailWidget } from '../types';

export const DEFAULT_LOCALE = 'vi-VN';

export const ADMIN_ROLE = 0;

export const USER_ROLE = 1;

export const ACCOUNT_IS_VERIFIED = true;

export const ACCOUNT_IS_NOT_VERIFIED = false;

export const ACTIVE_STATUS = true;

export const DISABLED_STATUS = false;

export const AUTH_LOGIN_PATH = '/auth/login';

export const AUTH_REGISTER_PATH = '/auth/register';

export const ADMIN_BASE_PATH = '/admin';

export const MY_ACCOUNT_PATH = '/my-account';

export const DEFAULT_DAY_FORMAT = 'DD/MM/YYYY';

export const EMAIL_VERIFICATION_QUERY_PARAMS = 'emailVerificationToken';

export const MAX_ALLOW_UPLOAD_PRODUCT_IMAGE = 5;

export const PAGE_QUERY_STRING_KEY = 'page';

export const RECORD_PER_PAGE_QUERY_STRING_KEY = 'limit';

export const DEFAULT_RECORDS_PER_PAGE_VALUE = 10;

export const KEYWORD_QUERY_STRING_KEY = 'search';

export const DEFAULT_TIME_FORMAT = 'HH:mm:ss';

export const DEFAULT_DAY_TIME_FORMAT = DEFAULT_DAY_FORMAT + ' ' + DEFAULT_TIME_FORMAT;

export const DEFAULT_TIMEZONE = 'Asia/Ho_Chi_Minh';

export const EN_US_LOCALE = 'en-US';

export const MINIMUM_PRODUCT_IN_DEAL = 1;

export const MAXIMUM_INSTAGRAM_LINK = 1;

export const FILTER_BY_CATEGORY_QUERY_STRING_KEY = 'category';

export const FILTER_BY_PRICE_QUERY_STRING_KEY = 'price';

export const MULTIPLE_FILTER_SPLIT_SYMBOL = ';';

export const PRICE_CALCULATE_UNIT = 1000;

export const SORT_BY_ALPHABETICALLY_A_Z = 'a_z';

export const SORT_BY_ALPHABETICALLY_Z_A = 'z_a';

export const SORT_BY_PRICE_LOW_TO_HIGH = 'price_low_to_high';

export const SORT_BY_PRICE_HIGH_TO_LOW = 'price_high_to_low';

export const SORT_BY_QUERY_STRING_KEY = 'sort';

export const productDetailWidgets: IProductDetailWidget[] = [
  {
    widgetId: '8d83f880-3773-4dfa-a20a-9e72d31c261f',
    title: 'labels.world_wide_shipping'
  },
  {
    widgetId: '5a68bd14-8c2f-4028-9e7c-32154de27c9a',
    title: 'labels.free_returning_days'
  },
  {
    widgetId: '3c385edc-2b23-4185-b547-86b490146729',
    title: 'labels.month_warranty'
  },
  {
    widgetId: '05eb1ea7-e5e4-4b2c-a9f4-28b17a39ef92',
    title: 'labels.secure_checkout'
  }
];
